import {
  SIGN_REQUEST,
  SIGN_SUCCESS,
  SIGN_FAILURE,
  SIGN_RESET,
} from "../actions/sign";

const initialState = {
  state: "idle",
};

export default function sign(state = initialState, action) {
  switch (action.type) {
    case SIGN_REQUEST:
      return {
        ...state,
        state: "loading",
      };
    case SIGN_SUCCESS:
      return {
        ...state,
        ...action.payload,
        state: "success",
      };
    case SIGN_FAILURE:
      return {
        ...state,
        ...action.payload,
        state: "failure",
      };
    case SIGN_RESET:
      return {
        ...initialState,
      };
    default:
      return state;
  }
}
